import React from 'react';
import styled from 'styled-components';

interface IPaymentIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<IPaymentIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Payment = ({ user = 'landlord' }: IPaymentIconProps): JSX.Element => (
  <StyledSvg
    user={user}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <path
      d="M32.227 15.583H17.802a4.345 4.345 0 001.073-2.86 4.37 4.37 0 00-4.365-4.365 4.37 4.37 0 00-4.364 4.365c0 1.093.405 2.093 1.072 2.86H7.774a3.778 3.778 0 00-3.773 3.774v4.452a.755.755 0 101.51 0v-4.452a2.267 2.267 0 012.263-2.264h21.132a2.267 2.267 0 012.264 2.264v4.075h-7.849a3.778 3.778 0 00-3.773 3.774 3.778 3.778 0 003.773 3.773h7.85v4.075a2.267 2.267 0 01-2.265 2.265H7.774a2.267 2.267 0 01-2.264-2.265v-4.458a.755.755 0 10-1.509 0v4.458a3.778 3.778 0 003.773 3.774h24.453A3.778 3.778 0 0036 35.054V19.357a3.778 3.778 0 00-3.773-3.774zM14.51 9.868a2.858 2.858 0 012.855 2.855 2.858 2.858 0 01-2.855 2.855 2.858 2.858 0 01-2.855-2.855 2.858 2.858 0 012.855-2.855zm17.413 7.225h.304a2.267 2.267 0 012.264 2.264v4.075H32.68v-4.075c0-.85-.282-1.633-.757-2.264zM21.057 27.206a2.267 2.267 0 012.264-2.264h11.17v4.528H23.32a2.267 2.267 0 01-2.264-2.264zm11.17 10.113h-.304a3.753 3.753 0 00.757-2.265V30.98h1.81v4.075a2.267 2.267 0 01-2.263 2.265z"
      fill="#000"
    />
    <path
      d="M23.128 26.45a.76.76 0 00-.535.222.76.76 0 000 1.067c.142.14.335.221.535.221.198 0 .392-.08.533-.221a.76.76 0 00.221-.534.76.76 0 00-.22-.533.76.76 0 00-.534-.221zM25.49 10.496a4.37 4.37 0 004.365-4.364 4.37 4.37 0 00-4.364-4.365 4.37 4.37 0 00-4.365 4.365 4.37 4.37 0 004.365 4.364zm0-7.22a2.858 2.858 0 012.856 2.856 2.858 2.858 0 01-2.855 2.855 2.858 2.858 0 01-2.856-2.855 2.858 2.858 0 012.856-2.855zM18.12 7.547a.755.755 0 00.756-.755V.862a.755.755 0 10-1.51 0v5.93c0 .417.338.755.755.755zM14.497 4.937a.755.755 0 00.755-.755V.862a.755.755 0 10-1.51 0v3.32c0 .417.338.755.755.755zM4.756 27.96a.76.76 0 00.533-.221.76.76 0 00.221-.534.759.759 0 00-.755-.755.76.76 0 00-.533.222.76.76 0 00-.221.533c0 .199.08.394.221.534a.76.76 0 00.534.221z"
      fill="#000"
    />
  </StyledSvg>
);

export default Payment;
